







































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditGoodstype from "@/views/goods/goodstype/edit-goodstype.vue"
import CreateGoodstype from "./create-goodstype.vue"
 

 

class PageGoodstypeRequest extends PageRequest {
  Keyword: string;
  //isrent: number; //nullable
  stime: Date;
  etime: Date;
}

@Component({
  components: { EditGoodstype,CreateGoodstype },
                                   
})
export default class Goodstype extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageGoodstypeRequest = new PageGoodstypeRequest();
  creationTime: Date[] = [];
  editModalShow: boolean = false;
  createModalShow: boolean = false;
   

  get list() {

   return this.$store.state.goodstype.list;
  }
  get loading() {
     
    return this.$store.state.goodstype.loading;
  }
  create() {
     this. createModalShow=true;
  }

  pageChange(page: number) {
    this.$store.commit("goodstype/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("goodstype/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    if (this.creationTime.length > 0) {
      this.pagerequest.stime = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.etime = this.creationTime[1];
    }

    await this.$store.dispatch({
      type: "goodstype/getAll",
      data: this.pagerequest,
    });
  }
  
  get pageSize() {
    return this.$store.state.goodstype.pageSize;
  }
  get totalCount() {
    return this.$store.state.goodstype.totalCount;
  }
  get currentPage() {
    return this.$store.state.goodstype.currentPage;
  }

  columns = 
  [
                    {
                        title: '11',
                       // key: 'goodsTypename',
                        //tree: true,
                                 
                         render: (h: any, params: any) => {
                                   let th='订单'
                                   var lhs=this;
                                 
 
                                return h(th)}
                        

                    },
                     {
                        title: 'Name',
                        key: 'goodsTypename',
                       
                        
                    }
                    ,
                    
                    {
                        title: 'goodsTypeDetail',
                        key: 'goodsTypeDetail'
                    },
                   
                ]
  /*[
     

      {
       title: this.L("分类名称"),
       key: "goodsTypename",
       tree:true,
     
       
      
    },

    {
      title: this.L("分类描述"),
      key: "goodsTypeDetail",
     
      
     
    },
    
     {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                
                  this.$store.commit("goodstype/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteUserConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "goodstype/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];*/
    async getAllData() {
    await this.$store.dispatch({
      type: "goodstype/getAllData",
    });
  }
  async created() {
    this.getpage();
    this.getAllData();
    
  }
  Formatter(row, column){
     return row.goodsTypename;
}
deleteRow(row, column){

                  this.$store.commit("goodstype/edit", column);
                  this.edit();

}

addRow(row, column){
  if(column==null){
           column=new Array();
           column.id=0;

  }

                  this.$store.commit("goodstype/edit", column);
                  this.create();

}



}
